module.exports = __webpack_public_path__ + "img/chart4.8699b95f.png";